interface IssuedInvoicePanelProps {
  url: string;
  onCopy?: () => void;
}

export function IssuedInvoicePanel({ url, onCopy }: IssuedInvoicePanelProps) {
  return (
    <div className="bg-surface-secondary rounded-lg p-4">
      <div className="text-xs text-content-tertiary uppercase tracking-wider font-medium mb-1.5">
        Payment link
      </div>
      <div className="flex items-center gap-2">
        <div className="flex-1 min-w-0 text-xs text-content-secondary font-mono truncate">
          {url}
        </div>
        {onCopy && (
          <button
            onClick={onCopy}
            className="shrink-0 text-xs font-medium text-primary hover:underline"
          >
            Copy link
          </button>
        )}
        <button
          onClick={() =>
            window.open(
              url,
              "_blank",
              "noopener",
            )
          }
          className="shrink-0 text-xs font-medium text-content-secondary hover:text-content-primary"
        >
          Open ↗
        </button>
      </div>
      <div className="text-xs text-content-tertiary mt-2">
        Share this link with the customer to collect payment.
      </div>
    </div>
  );
}
